
import Name from './name.vue';
import Type from './type.vue';
import BeginTime from './begintime.vue';
import Students from './students.vue';
import Duration from './duration.vue';
import Recorded from './recorded.vue';
import Cover from './cover.vue';
import Remark from './remark.vue';
import Inside from './inside.vue';
import Outside from './outside.vue';
import Watermark from './watermark.vue';
import Logo from './logo.vue';
import Teacher from './teacher.vue';
import Location from './location.vue';
import OpenRange from './openrange.vue';
import { isObject } from 'lodash';

const defaultFileds = [
  'type',
  'name',
  'teacher',
  'begintime',
  'duration'
];

const filedsComp = [
  {label: 'pc_biz_liveType' /* 直播类型 */, compName: Type.name, comp: Type, prop: 'type'},
  {label: 'pc_biz_livename' /* 直播名称 */, compName: Name.name, comp: Name, prop: 'roomName'},
  {label: 'pc_biz_startTime' /* 开始时间 */, compName: BeginTime.name, comp: BeginTime, prop: 'beginTime'},
  {label: 'pc_biz_designatedPersonnel' /* 指定人员 */, compName: Students.name, comp: Students, prop: 'students'},
  {label: 'pc_biz_teacher' /* 主讲人 */, compName: Teacher.name, comp: Teacher, prop: 'teacher'},
  {label: 'pc_biz_expectDuration' /* 预计时长 */, compName: Duration.name, comp: Duration, prop: 'duration'},
  {label: 'pc_biz_allowPlayback' /* 允许回放 */, compName: Recorded.name, comp: Recorded, prop: 'recorded'},
  {label: 'pc_biz_livecover' /* 直播封面 */, compName: Cover.name, comp: Cover, prop: 'cover'},
  {label: 'pc_biz_liveremark' /* 直播介绍 */, compName: Remark.name, comp: Remark, prop: 'remark'},
  {label: 'pc_biz_internalDisclosure' /* 对内公开 */, compName: Inside.name, comp: Inside, prop: 'inside'},
  {label: 'pc_biz_openToPublic' /* 对外公开 */, compName: Outside.name, comp: Outside, prop: 'outside'},
  {label: 'pc_biz_courseLocation' /* 课程地点 */, compName: Location.name, comp: Location, prop: 'liveLocation'},
  {label: 'pc_biz_startWaterMark' /* 开启水印 */, compName: Watermark.name, comp: Watermark, prop: 'waterMark'},
  {label: 'pc_biz_openlogo' /* 打开logo */, compName: Logo.name, comp: Logo, prop: 'showLogo'},
  {label: 'pc_biz_openrange' /* 公开范围 */, compName: OpenRange.name, comp: OpenRange, prop: 'selectOrgIds'}
];
const validateTime = (vm, rule, value, callback) => {
  if (!value || value.length === 0) {
    callback(new Error(vm.$t('pc_biz_liveStartTime' /* 请设置开播时间 */)));
  } else if (value.getTime() < new Date().getTime()) {
    callback(
      new Error(
        vm.$t('pc_biz_notBeforeNow' /* 开始时间不可早于当前时间 */),
      ),
    );
  } else if (new Date(value).getFullYear() > 9999) {
    callback(
      new Error(
        vm.$t('pc_biz_maxStartYear' /* 开始时间的年份不能大于9999 */),
      ),
    );
  } else {
    callback();
  }
};
const validuration = (vm, rule, value, callback) => {
  if (!value || value === 0) {
    callback(
      new Error(
        vm.$t('pc_biz_moreThan' /* 请设置不少于1分钟的直播时长 */),
      ),
    );
  } else {
    callback();
  }
};
const valiteacher = (vm, rule, value, callback) => {
  if (!value.length) {
    callback(
      new Error(vm.$t('pc_biz_oneTeacher' /* 请选择至少一位老师 */)),
    );
  } else {
    callback();
  }
};
const valistudent = (rule, value, callback) => {
  callback();
};
const getFiledsRules = (vm)=>({
  roomName: [
    {
      required: true,
      message: vm.$t('pc_biz_enterName' /* 请输入直播名称 */),
      trigger: 'blur'
    },
    {
      max: 50,
      message: vm.$t(
        'pc_biz_characterRange' /* 长度在{0}个字符内 */,
        ['50'],
      ),
      trigger: 'blur'
    }
  ],
  beginTime: [
    { required: true, validator: (...args)=> validateTime(vm, ...args), trigger: 'change' }
  ],
  duration: [
    { required: true, validator: (...args)=>validuration(vm, ...args), trigger: ['change', 'blur'] }
  ],
  teacher: [
    { required: true, validator: (...args)=>valiteacher(vm, ...args), trigger: 'change' }
  ],
  selectOrgIds: [
    {
      required: true,
      message: vm.$t('pc_biz_chooseOrgId' /* 请选择可以观看直播的平台 */),
      trigger: 'blur'
    }
  ],
  students: [{ required: true, validator: valistudent }],
  inside: [{ required: true, validator: valistudent }],
  outside: [{ required: true, validator: valistudent }]
});
const getFiledsComp = (fileds, {inside})=>{
  fileds = Array.from(new Set([...defaultFileds, ...fileds]));
  if (!inside.inside && !inside.publishType) {
    const index = fileds.findIndex(item=>item === 'openrange' || item.fieldName === 'openrange');
    index > -1 && fileds.splice(index, 1);
  }
  return fileds.map(filed=>{
    const fieldName = isObject(filed) ? filed.fieldName : filed;
    console.log(fieldName);
    if (!fieldName) return null;
    const comp = filedsComp.find(comp=>{
      return comp.compName.toLowerCase() === 'live' + fieldName;
    });
    if (comp) {
      return filed.fieldName ? {...comp, ...filed} : comp;
    }
    throw new Error(`当前fileds【${fieldName}】不存在，请检查fileds配置`);
  }).filter(item=>item);
};

export {
  getFiledsRules,
  getFiledsComp
};
